import React from "react";
import useIsMobile from "../../SupportingFiles/MobileProvider";
import MOnlineTransactionJourney from "../../Pages/Mobile/MProductPages/MOnlineTransactionJourney/MOnlineTransactionJourney";
import OnlineTransactionJourney from "../../Pages/Desktop/ProductPages/OnlineTransactionJourney/OnlineTransactionJourney";

const OTJourneyContainer = () => {
  const isMobile = useIsMobile();
  return isMobile ? (
    <MOnlineTransactionJourney />
  ) : (
    <OnlineTransactionJourney />
  );
};

export default OTJourneyContainer;
